const TopNavBarSpan = ({
  topTab,
  setTopTab,
  worksheetTabName,
  setWorksheetTab,
  tabName,
  tabText,
}) => {
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        fontWeight: topTab === tabName ? "bold" : "normal",
        height: "100%",
      }}
      onClick={() => {
        setTopTab(tabName);
        setWorksheetTab(worksheetTabName);
      }}
    >
      {tabText}
    </span>
  );
};

export default TopNavBarSpan;
